import {Box} from '@mui/material';

import {PAYMENT_LINK_IMAGES} from '@/app/main/paymentLink/models/constants/paymentLink.constants';

export const PaymentLinkLogo = () => (
  <Box className="payment-link-logo-container">
    <img
      src={PAYMENT_LINK_IMAGES.MODAK_LOGO.src}
      alt={PAYMENT_LINK_IMAGES.MODAK_LOGO.alt}
      style={{
        width: PAYMENT_LINK_IMAGES.MODAK_LOGO.width,
        height: PAYMENT_LINK_IMAGES.MODAK_LOGO.height,
      }}
    />
  </Box>
);
